export type ImageFitMode = 'clip' | 'scale' | 'crop';
export type ImageFormat = 'gif' | 'png' |'png8' | 'jpg' | 'pjpg' |'webp';
export type ImageCompression = 'lossless' | 'lossy';

